module.exports = ":host .u-radio {\n  min-width: 100px; }\n\n/*\n&.justify-center {\n    justify-content: center;\n} */\n"